import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(String(reader.result).split(',')[1]);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

// A programmatic <a download> click (the browser/PWA way of saving a
// generated file) silently does nothing inside Android's WebView, which is
// what every native build runs in -- there's no download manager to hand it
// to. On native, write the file to app storage instead and hand it to the
// OS Share sheet, which lets the user save it to Files, email it, etc.
// Behaviour on web/PWA is completely unchanged.
export async function downloadBlob(blob, filename) {
  if (!Capacitor.isNativePlatform()) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    return;
  }
  const base64 = await blobToBase64(blob);
  const written = await Filesystem.writeFile({ path: filename, data: base64, directory: Directory.Cache });
  await Share.share({ title: filename, url: written.uri });
}
